import { ActivatedRouteSnapshot } from '@angular/router';

import { ClientConfigProductName } from '@frontend/vanilla/core';

import { SamePathAppVersion } from '../app.version.enum';
import {
    allowedProductGuard,
    isActiveProductGuard,
    isSportsVersionMatch,
    matchAppVersionProductLoadGuard,
    productUnderMaintenanceGuard,
} from '../guards';
import { viewTransitionAnimationGuard } from '../view-transition/view-transition-animation.guard';
import { RoutesConfig } from './routes-config';

const routes: Required<RoutesConfig> = {
    routes: [
        {
            path: 'sports',
            loadChildren: () => import('@frontend/sports/web/entrypoint-lib').then((t) => t.SPORTS_WEB_ROUTES),
            canMatch: [
                allowedProductGuard,
                (route: ActivatedRouteSnapshot) =>
                    matchAppVersionProductLoadGuard(ClientConfigProductName.SPORTS, SamePathAppVersion.SPORTS_WEB_APP, route),
            ],
            canActivateChild: [viewTransitionAnimationGuard],
            canActivate: [
                (route: ActivatedRouteSnapshot) =>
                    productUnderMaintenanceGuard(route, ClientConfigProductName.SPORTS, SamePathAppVersion.SPORTS_WEB_APP),
            ],
            data: {
                product: ClientConfigProductName.SPORTS,
                canPreload: [isSportsVersionMatch(SamePathAppVersion.SPORTS_WEB_APP), allowedProductGuard],
            },
        },
    ],
    topLevelRoutes: [
        {
            path: '',
            outlet: 'overlay',
            canActivateChild: [viewTransitionAnimationGuard],
            canMatch: [isActiveProductGuard(ClientConfigProductName.SPORTS)],
            loadChildren: () => import('@frontend/sports/web/entrypoint-lib').then((t) => t.SPORTS_SECONDARY_ROUTES),
        },
    ],
};

export default routes;
